<template lang="pug">
  //- Wir binden die Klasse 'expanded' dynamisch, damit das CSS in App.vue greifen kann
  div.ui.sidebar.vertical.menu.visible.mini-sidebar(:class="{ expanded: isExpanded }")
    
    //- Sidebar-Toggle
    div.item.sidebar-header(@click="$emit('toggle')")
        i.layer.group.icon
        span.nav-text ZMÜK 2.0
    
    //- Navigations-Links
    router-link.item(
        v-bind:to='{ name: "products" }'
        v-bind:class="{ active: isProductsActive }"
        v-if="showProducts"
    )
        i.mail.bulk.icon
        span.nav-text Produkte

    router-link.item(
        v-bind:to='{ name: "jobs" }'
        v-bind:class="{ active: isJobsActive }"
        v-if="showJobs"
    )
        i.tasks.icon
        span.nav-text Jobverwaltung

    router-link.item(
        v-bind:to='{ name: "companies" }'
        v-bind:class="{ active: isCompaniesActive }"
        v-if="showCompanies"
    )
        i.city.icon
        span.nav-text Unternehmen

    router-link.item(
        v-bind:to='{ name: "addresses" }'
        v-bind:class="{ active: isAddressesActive }"
        v-if="showAddresses"
    )
        i.address.book.icon
        span.nav-text Adressen

    router-link.item(
        v-bind:to='{ name: "users" }'
        v-bind:class="{ active: isUsersActive }"
        v-if="showUsers"
    )
        i.user.friends.icon
        span.nav-text Benutzer

    router-link.item(
        v-bind:to='{ name: "agencies" }'
        v-bind:class="{ active: isAgenciesActive }"
        v-if="showAgencies"
    )
        i.toolbox.icon
        span.nav-text Agenturen

    router-link.item(
        v-bind:to='{ name: "archive" }'
        v-bind:class="{ active: isArchiveActive }"
        v-if="showArchive"
    )
        i.archive.icon
        span.nav-text Archiv
    
    router-link.item(
        v-bind:to='{ name: "settings" }'
        v-bind:class="{ active: isSettingsActive }"
        v-if="showSettings"
    )
        i.sliders.horizontal.icon
        span.nav-text Einstellungen

    //- Unten platzierte Controls (Theme & User)
    //- div.bottom-controls(style="position: absolute; bottom: 0; width: 100%; border-top: 1px solid rgba(255,255,255,0.1)")
    //-     div.item
    //-       theme-controls
    //-     div.item
    //-       user-menu-dropdown
    user-menu-dropdown-sidebar(:isExpanded="isExpanded")
</template>

<script>
    import UserMenuDropdownSidebar from './UserMenuDropdownSidebar.vue'
    import ThemeControls from './ThemeControls.vue'

    //noinspection JSUnusedGlobalSymbols
    export default {

        components: { UserMenuDropdownSidebar, ThemeControls },

        props: {
            isExpanded: {
                type: Boolean,
                default: false
            }
        },

        computed: {

            currentRoute() {
                return this.$route.path
            },

            isProductsActive() {
                return this.currentRoute.startsWith('/products') || this.currentRoute.startsWith('/campaigns')
            },

            isJobsActive() {
                return this.currentRoute.startsWith('/jobs')
            },

            isCompaniesActive() {
                return this.currentRoute.startsWith('/companies')
            },

            isUsersActive() {
                return this.currentRoute.startsWith('/users')
            },

            isAddressesActive() {
                return this.currentRoute.startsWith('/addresses') || this.currentRoute.startsWith('/persons')
            },

            isAgenciesActive() {
                return this.currentRoute.startsWith('/agencies')
            },

            isArchiveActive() {
                return this.currentRoute.startsWith('/archive')
            },

            isSettingsActive() {
                return this.currentRoute.startsWith('/settings')
            },

            activeRole() {
                return this.$auth.activeRole
            },

            showAddresses() {
                return ['ADMIN', 'CUSTOMER', 'MEDIA_PRODUCTION'].includes(this.activeRole)
            },

            showAgencies() {
                return ['ADMIN', 'CUSTOMER'].includes(this.activeRole)
            },

            showArchive() {
                return ['ADMIN', 'CUSTOMER', 'MEDIA_PRODUCTION'].includes(this.activeRole)
            },

            showSettings() {
                return ['ADMIN'].includes(this.activeRole)
            },

            showCompanies() {
                return ['ADMIN', 'MEDIA_PRODUCTION'].includes(this.activeRole)
            },

            showJobs() {
                return ['ADMIN', 'AGENCY', 'SUPPLIER'].includes(this.activeRole)
            },

            showProducts() {
                return ['ADMIN', 'CUSTOMER', 'MEDIA_PRODUCTION'].includes(this.activeRole)
            },

            showStats() {
                return ['ADMIN'].includes(this.activeRole)
            },

            showUsers() {
                return this.$auth.isZmuekish
            }

        }

    }

</script>

<style scoped>
    /* Basis-Leiste: nur Positionierung, kein visueller Stil */
    .ui.top.fixed.menu {
        background: transparent !important;
        border-bottom: none !important;
        box-shadow: none !important;
        height: 3rem;
        min-height: 3rem;
    }

    /* Visueller Stil liegt auf dem Container → etwas breiter als der Content */
    .ui.top.fixed.menu > .ui.container {
        background-color: var(--sidebarBackground);
        border: 1px solid var(--solidBorderColor);
        border-top: none;
        border-radius: 0 0 0.5rem 0.5rem;
        box-shadow: var(--subtleShadow);
        height: 3rem;
        width: calc(100% - 1rem) !important;
        max-width: 1130px !important;
        margin-left: auto !important;
        margin-right: auto !important;
    }

    /* Menu Items */
    .ui.menu .item {
        color: var(--textColor);
        font-weight: 500;
        border-radius: 0;
        transition: all 0.15s ease;
    }

    /* Hover */
    .ui.menu .item:hover,
    .ui.menu .item.active:hover {
        background-color: transparent;
        color: var(--primaryColor);
    }

    /* Aktiver Link */
    .ui.menu .router-link-active.item,
    .ui.menu .router-link-exact-active.item,
    .ui.menu .item.active {
        background-color: color-mix(in srgb, var(--primaryColor), transparent 90%);
        color: var(--primaryColor);
        font-weight: 600;
    }

    /* Icons etwas kleiner & näher am Text */
    .ui.menu .item > i.icon {
        font-size: 1.275rem;
        margin-right: 0.375rem;
        opacity: 0.75;
    }

    /* Remove divider line between items */
    .ui.menu .item::before {
        width: 0px !important;
    }

    /* Eckradien auf die Eck-Items übertragen */
    .ui.top.fixed.menu > .ui.container > .item:first-child {
        border-bottom-left-radius: 6px !important;
    }

    .ui.top.fixed.menu > .ui.container > .right.menu > .item:last-child {
        border-bottom-right-radius: 6px !important;
        border-bottom: none !important;
    }

    /* Die Sidebar ist im Grundzustand schmal */
    .ui.sidebar.vertical.menu.mini-sidebar {
        width: 70px !important;
        transition: width 0.3s ease !important;
        /* overflow-x: hidden !important; */
        display: flex !important;
        flex-direction: column;
        box-shadow: 10px 3px 8px rgba(34, 36, 38, 0.04);
    }

    /* Erweitert */
    .ui.sidebar.vertical.menu.mini-sidebar.expanded {
        width: 280px !important;
    }

    /* Texte standardmäßig ausgeblendet – animierbar statt display:none.
       display lässt sich nicht animieren; ein Umschalten zwischen none und
       inline-block würde den Text schlagartig ein-/ausblenden (Glitch). */
    .nav-text {
        display: inline-block;
        max-width: 0;
        opacity: 0;
        overflow: hidden;
        white-space: nowrap;
        vertical-align: middle;
        margin-left: 0;
        transition: max-width 0.3s ease, opacity 0.3s ease, margin-left 0.3s ease;
    }

    /* Texte einblenden wenn expanded */
    .expanded .nav-text {
        max-width: 200px;
        opacity: 1;
        margin-left: 10px;
    }

    /* Icons sitzen in collapsed UND expanded an derselben x-Position.
       Flex zentriert vertikal; der feste linke Abstand zentriert das
       1.5em-Icon (font-size 1.275rem => 1.9125rem) in der 70px-Leiste
       und bleibt beim Aufklappen unverändert. */
    .ui.menu.vertical .item:not(.user-menu-trigger) {
        display: flex !important;
        align-items: center !important;
        height: 50px;
        padding: 0 !important;
        padding-left: calc((70px - 1.9125rem) / 2) !important;
        /* Aktive Markierung über border-right statt border-bottom:
           konstante 2px verhindern den Layout-Shift und das beim Klick
           kurz aufblitzende blaue Unterstreichungs-Border. */
        border-right: 2px solid transparent;
    }

    /* User-Menü (Trigger) behält sein bisheriges Layout */
    .ui.menu.vertical .item.user-menu-trigger {
        text-align: center;
        padding: 1.2em 0 !important;
        height: 50px;
    }

    .expanded.ui.menu.vertical .item.user-menu-trigger {
        text-align: left;
        padding: 1em 1.14em !important;
    }

    /* Aktiver Link Style (angepasst an vertikal).
       Nur die Farbe wechseln (Breite bleibt 2px), damit die Markierung
       sauber einblendet statt zu "poppen". */
    .ui.menu.vertical .item.active {
        background-color: rgba(255, 255, 255, 0.1) !important;
        border-right-color: var(--primaryColor);
    }

    /* Hover-Effekt */
    .ui.menu.vertical .item:hover {
        background: rgba(255, 255, 255, 0.05) !important;
    }

    /* Icons fixieren damit sie nicht springen */
    .ui.menu.vertical .item > i.icon {
        float: none !important;
        margin: 0 !important;
        width: 1.5em;
    }
    .expanded.ui.menu.vertical .item > i.icon {
        margin-right: 0.5em !important;
    }

    /* User-Menü immer am unteren Rand */
    .user-menu-trigger {
        margin-top: auto !important;
    }
</style>
